import type { DocNode } from '@atlaskit/adf-schema/doc';
import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

type ParseADF = {
	contentId: string;
	createAnalyticsEvent: CreateUIAnalyticsEvent;
};

export const getADFParser = ({ contentId, createAnalyticsEvent }: ParseADF) => {
	return (adf: string | null): DocNode => {
		if (adf) {
			try {
				return JSON.parse(adf);
			} catch (error) {
				createAnalyticsEvent({
					type: 'sendOperationalEvent',
					data: {
						action: 'error',
						actionSubject: 'pagePropertiesReport',
						source: 'parseADF',
						attributes: {
							contentId,
						},
					},
				}).fire();
			}
		}

		return {
			version: 1,
			type: 'doc',
			content: [],
		};
	};
};
